import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";
import { useGetMyFeatures } from "@tubo/api-models/hooks/tenant-feature-api.hooks";
import { Button } from "@tubo/ui/components/ui/button";
import { useUiTranslation } from "@tubo/ui/i18n";

export const Route = createFileRoute("/_app/semantic-platform/vocabularies")({
  component: ConceptManageLayout,
});

/**
 * 概念管理路由级 Feature 门禁(波次7 决策 2)
 *
 * semanticData.semanticAsset 未开启的租户:侧栏隐藏(主会话统一接线)+ URL 直接访问被拦截。
 */
function ConceptManageLayout() {
  const { t } = useUiTranslation("semanticPlatform");
  const navigate = useNavigate();
  const { data: features, isLoading } = useGetMyFeatures({ query: {} });

  if (isLoading) {
    return <div className="flex h-full items-center justify-center text-muted-foreground">{t("common.loading")}</div>;
  }

  if (!features?.semanticAsset) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        <div className="text-center">
          <BookOpen className="mx-auto mb-3 h-12 w-12 text-icon-secondary-muted" />
          <p className="text-sm font-medium">{t("common.semanticAssetManagement")}</p>
          <p className="mt-1 text-xs text-muted-foreground/70">{t("navigation.unavailable")}</p>
          {/* 直链进入时浏览器历史可能是空/站外，返回固定落知识本体域首页 */}
          <Button variant="outline" size="sm" className="mt-4" onClick={() => navigate({ to: "/semantic-platform" })}>
            {t("common.back")}
          </Button>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
